import CustomConfigurator from "../../../../../app/javascript/CustomConfigurator";

import CustomSPVExternalIdInput from "../components/CustomSPVExternalIdInput";
import SpvCatalogFields from "../components/composer/SpvCatalogFields";

CustomConfigurator.set(
  ["rundschreiben", "ExternalIdInput"],
  CustomSPVExternalIdInput,
);

CustomConfigurator.set(["activityComposer", "ExtraFields"], SpvCatalogFields);
